import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  /** Used by payment-success wait screen in app.component */
  paymentReady$ = new Subject<void>();

  /**
   * MatBottomSheet allows only ONE sheet at a time. A second open() dismisses
   * the first mid-animation (looks like open → close → reopen). Guard rapid
   * duplicate opens from double-firing click/touch handlers.
   */
  private activeBottomSheetRef: MatBottomSheetRef<any> | null = null;
  private lastBottomSheetOpenAt = 0;
  private readonly bottomSheetOpenGuardMs = 500;

  notifyPaymentReady() {
    this.paymentReady$.next();
  }

  constructor(private httpClient: HttpClient,
    private _bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
  ) {
  }

  private openBottomSheetSafe(
    componentName: any,
    config: { data?: any; panelClass?: any; disableClose?: boolean }
  ): MatBottomSheetRef<any> {
    const now = Date.now();
    if (
      this.activeBottomSheetRef &&
      now - this.lastBottomSheetOpenAt < this.bottomSheetOpenGuardMs
    ) {
      return this.activeBottomSheetRef;
    }

    this.lastBottomSheetOpenAt = now;
    const ref = this._bottomSheet.open(componentName, {
      disableClose: false,
      ...config,
    });
    this.activeBottomSheetRef = ref;
    ref.afterDismissed().subscribe(() => {
      if (this.activeBottomSheetRef === ref) {
        this.activeBottomSheetRef = null;
      }
    });
    return ref;
  }

  openBottomSheetWithHeight(componentName: any, data: any, className: any) {
    return this.openBottomSheetSafe(componentName, {
      data,
      panelClass: className,
      disableClose: false,
    });
  }
  openBottomSheet(componentName: any, data: any) {
    return this.openBottomSheetSafe(componentName, {
      data,
      disableClose: false,
    });
  }

  openDialog(componentName:any, height:any, width:any, dataModel:any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }
  // home page Api 

  getAllHomeData() {
    return this.httpClient.get(
      environment.baseUrl + `landing`
    )
  }


  // store api 


  getAllStores(pageNo: number, size: number, storeIds: any) {
    return this.httpClient.get(
      environment.baseUrl + `store/?pageNo=${pageNo}&size=${20}&storeIds=${storeIds}`,
    )
  }


  searchStorebyName(pageNo: number, size: number, searchText: any, storeIds: any) {
    return this.httpClient.get(
      environment.baseUrl + `store/?pageNo=${pageNo}&size=${size}&searchText=${searchText}&storeIds=${storeIds}`
    )
  }


  // kyc Api

  kycUpdate(data: any, userId: any, panNumber: any, name:string, dateOfBirth: any) {
    return this.httpClient.put(
      environment.baseUrl + `user/update/KYC?userId=${userId}&panNumber=${panNumber}&name=${name}&dateOfBirth=${dateOfBirth}`, data
    )
  }


  // passbook cashfree api for manual

  doCashfree(data: any, manualPay: boolean) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/initiate/payment?manualPay=${manualPay}`, data
    )
  }
  cartIniatePayment(data:any, manualPay:boolean){
    return this.httpClient.post(
      environment.baseUrl + `passbook/cart/initiate/payment?manualPay=${manualPay}`, data
    )
  }

  getGiftVoucher(campaignId: string) {
    return this.httpClient.get(
      environment.baseUrl + `gift-voucher/${encodeURIComponent(campaignId)}`
    );
  }

  checkGiftVoucher(voucherCode: string) {
    return this.httpClient.get(
      environment.baseUrl + `gift-voucher/check?voucherCode=${encodeURIComponent(voucherCode)}`
    );
  }

  directEnroll(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/direct/enroll`, data
    )
  }

  directInstallmentPayment(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/direct/installment/payment`, data
    )
  }

  cashfreeForBackend(paymentOrderId: any) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/manual/payment/status?paymentOrderId=${paymentOrderId}`,
      {}
    )
  }

  cashFreeAutoPayBackend(paymentOrderId:any){
    return this.httpClient.post(
      environment.baseUrl + `passbook/auto/payment/status?paymentOrderId=${paymentOrderId}`,
      {}
    )
  }


  getPassbookData(userId: any) {
    return this.httpClient.get(
      environment.baseUrl + `passbook/user`
    )
  }

  getPassbookDataByStatus(passBookStatus: string) {
    return this.httpClient.get(
      environment.baseUrl + `passbook/user`,
      { params: { passBookStatus } }
    )
  }

  getPassbookDetailsById(Id:any){
    return this.httpClient.get(
      environment.baseUrl+`passbook/${Id}`
    )
  }
 
  //due-payments

getDuePayments(pageNo: number, size: number, businessId: any, userId: any){
    const url = `${environment.baseUrl}passbook/payment/dues?pageNo=${pageNo}&size=${size}&businessId=${businessId}&userId=${userId}`;
    return this.httpClient.get<any>(url);
  }


  // auto payment listing 

  getAutoPaymentListing(userId:any,subscriptionStatus:any){
    return this.httpClient.get(
      environment.baseUrl + `passbook/passbook/subscription/based?userId=${userId}&subscriptionStatus=${subscriptionStatus}`
    )
  }
  
  getManageAuto(subscriptionStatus:any,passBookId:any){
    return this.httpClient.get(
      environment.baseUrl + `payment/subscription/manage/?subscriptionStatus=${subscriptionStatus}&passBookId=${passBookId}`
    )
  }

  getPauseAutoPayment(subscriptionStatus:any,tillDate:any,passBookId:any){
    return this.httpClient.get(
      environment.baseUrl + `payment/subscription/manage/?subscriptionStatus=${subscriptionStatus}&tillDate=${tillDate}&passBookId=${passBookId}`
    )
  }


  getReceiptData(passBookId:any,transactionId:any){
    return this.httpClient.get(
      environment.baseUrl + `passbook/receipt?passBookId=${passBookId}&transactionId=${transactionId}`
    )
  }

  getInvoice(passbookId: any, transactionId: any, isRegenerate: boolean = false) {
    return this.httpClient.get(
      environment.baseUrl + `passbook/invoice?passbookId=${passbookId}&transactionId=${transactionId}&isRegenerate=${isRegenerate}`
    );
  }

  redemptionRequest(data:any){
    return this.httpClient.put(
      environment.baseUrl + `passbook/request/redemption?passBookId=${data.passBookId}`,{}
    )
  }


  // for profile data 

  getUserDetailsByUserId(userId: any) {
    return this.httpClient.get(
      environment.baseUrl + `user?userId=${userId}`
    )
  }

  editProfile(data: any) {
    return this.httpClient.put(
      environment.baseUrl + `user/update`, data
    )
  }


  // for scheme visit 


  scheduleVisit(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `scheduleVisit/create`,
      data
    )
  }

  getVisitById(id:any){
    return this.httpClient.get(
      environment.baseUrl+`scheduleVisit/get/${id}`
    )
  }

  scheduleProfileListing(userId:any,visitStatus:any,pageNo:any,size:any){
    return this.httpClient.get(
      environment.baseUrl + `scheduleVisit/status?userId=${userId}&visitStatus=${visitStatus}&pageNo=${pageNo}&size=${size}`
    )
  }

  changeVisitStatus(data:any){
    return this.httpClient.put(
      environment.baseUrl + `scheduleVisit/changeStatus/${data.visitId}?visitStatus=${data.status}`,data
    )
  }


  // nominee api 

  nomineeCreation(data: any, userId: any) {
    return this.httpClient.put(
      environment.baseUrl + `user/update/nominee?userId=${userId}`,
      data
    )
  }
    nomineeCreationv2(data: any) {
    return this.httpClient.put(
      environment.baseUrl + `user/v2/update/nominee`,
      data
    )
  }


  getNomineeListing(userId: any) {
    return this.httpClient.get(
      environment.baseUrl + `user?userId=${userId}`
    )
  }


  //transaction related api's

  getListAllTransactions(data:any){
    return this.httpClient.put(
      environment.baseUrl+`passbook/customer/transactions`,data
    )
  }

  filterTransactions(data:any){
    return this.httpClient.put(
      environment.baseUrl+`passbook/customer/transactions`,data
    )
  }


  // redemption API 

  
  getRedemptionList(pageNo:number,size:number,userId:any,passBookStatus:any){
    return this.httpClient.get(
      environment.baseUrl + `passbook/customer/enrollments/filter?pageNo=${pageNo}&size=${size}&userId=${userId}&passBookStatus=${passBookStatus}`
    )
  }



  getThemes(data:any){
    return this.httpClient.put(
      environment.baseUrl + `business/ssp/url`,
      data
    )
  }

  getUserStaff(){
    return this.httpClient.get(
      environment.baseUrl + `user/staff`
    )
  }
  
  getReview(data: any) {
    return this.httpClient.put(
      environment.baseUrl + `user/store/review`, data
    )
  }
   getSlabData(passbookId: any) {
  return this.httpClient.post(
    environment.baseUrl + `passbook/benefit/percentages?passbookId=${passbookId}`,
    {} 
    );
  }
  
  getRates(storeId:any){
    return this.httpClient.get(
      environment.baseUrl + `dashboard/v1/metal/prices?id=${storeId}`,
{}
    )
  }
  getAllGoldPrices(data:any){
    return this.httpClient.put(
      environment.baseUrl + `dashboard/v2/metal/prices/history`, data
  )

  }
   getPaymentAttempt(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/payment/attempt`,
      data
    )
  }

    getGroupById(id: string): Observable<any> {
    const url = `${environment.baseUrl}group-plan/groups/${id}`;
    return this.httpClient.get(url);
  }

  getNotificationsCount() {
    return this.httpClient.get(
      environment.baseUrl + `notifications/count`
    );
  }

  getNotifications(page = 0, size = 20) {
    return this.httpClient.get(
      environment.baseUrl +`notifications/?page=${page}&size=${size}`
    );
  }


  markNotificationRead(notificationId: string) {
    return this.httpClient.put(
      environment.baseUrl + `notifications/${notificationId}/read`,
      {}
    );
  }
  
  getReferEarnData(getBusinessId: any, getUserId: any) {
    return this.httpClient.get(
      environment.baseUrl.replace("passbook/", "") + `api/refer/get/?businessId=${getBusinessId}&referrerId=${getUserId}`
    )
  }

  getReferralDetails(businessId: any, uniqueReferralId: any) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.get(
      url + `api/get-referral-details?businessId=${businessId}&uniqueReferralId=${uniqueReferralId}`
    )
  }

  linkClicks(businessId: any) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.post(
      url + `api/ssp/referral/clicks?referralProgramId=${businessId}`, {}
    )
  }

  getAllPrograms(businessId: any) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.get(
      url + `api/referrals/config/?tenantId=${businessId}`
    )
  }

  checkBusiness(businessId: string, appName: string) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.get(
      url + `app/app/check-app?businessId=${businessId}&appName=${appName}`
    )
  }

  checkBusinessPoints(orderValue: string, eventType: string, points: boolean) {
    const url = environment.baseUrl.split('/passbook')[0]
    return this.httpClient.get(
      url + `api/referrals/available-amount?businessId=${localStorage.getItem('bId')}&userId=${localStorage.getItem('userId')}&eventType=${eventType}&orderValue=${orderValue}&rewardPoints=${points}`
    )
  }

  fullPointsUsage(data: any) {
    return this.httpClient.post(
      environment.baseUrl + `passbook/initiate/payment/points`, data
    )
  }

  getActiveAppBanners(payload: {
    placement: string;
    platform: string;
    userSegment: string;
    schemeId: string | null;
    storeIds: string[] | null;
    businessId: string;
    active?: boolean;
  }) {
    const url = environment.baseUrl.split('/passbook')[0];
    return this.httpClient.put(url + `api/app-banners/list`, payload);
  }

  getDiscountsList(payload: {
    pageNo: number;
    size: number;
    searchText: string | null;
    status: string | null;
    type: string | null;
    sortBy: string;
    sortOrder: string;
    startDate: string | null;
    endDate: string | null;
  }) {
    const url = environment.baseUrl.split('/passbook')[0];
    return this.httpClient.post(url + `api/discounts/list`, payload);
  }

  getBusinessSubscription(businessId: string) {
    const url = environment.baseUrl.split('/passbook')[0];
    return this.httpClient.get(`${url}business-subscriptions/${businessId}`);
  }
}